export enum ParamType {
  CODE = "code",
  EMAIL = "email",
}
